import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Results, TrainingTestOutcome } from '../../../types'
import { get, post } from '../../../utils/api'
import { handleApiErrors } from '../../../utils/apiErrors'

export const usePromoteAnnotation = () => {
  const { t } = useTranslation()
  const [isPosting, setPosting] = useState(false)
  const [isFetching, setFetching] = useState(false)
  const [isPromoting, setPromoting] = useState(false)

  useEffect(() => {
    setPromoting(isPosting || isFetching)
  }, [isPosting, isFetching])

  const promote = (outcomeId: number) => {
    setPosting(true)
    post(`/training_test_outcomes/promote-predictions/`, {
      ids: [outcomeId],
    })
      .then(() => {
        toast.success(
          t('The prediction has been successfully promoted to annotation.')
        )
      })
      .catch(handleApiErrors)
      .finally(() => setPosting(false))
  }

  const promoteAnnotationByOutcome = (outcomeId: number) => {
    promote(outcomeId)
  }

  const promoteAnnotationByTrainingAndObservation = (
    trainingTestId: number,
    observationId: number
  ) => {
    setFetching(true)
    get<Results<TrainingTestOutcome>>(
      `/training_test_outcomes/?training_test=${trainingTestId}&observation=${observationId}&limit=1`
    )
      .then((data) => {
        promote(data.results[0].id)
      })
      .catch(handleApiErrors)
      .finally(() => setFetching(false))
  }

  return {
    isPromoting,
    promoteAnnotationByOutcome,
    promoteAnnotationByTrainingAndObservation,
  }
}
